/**
 * Бренд оформления демо-стенда: GMK (брендбук «GMK стиль») или оригинальный
 * Colver. Одна сборка и одна база на оба варианта — бренд выбирается по хосту
 * до первой отрисовки (inline-скрипт в `index.html` ставит `data-brand` на
 * `<html>`), отсюда его читают компоненты. Цвета — токены `app/index.css`
 * (GMK — блок `[data-brand='gmk']`), знаки — `@ui/brand`.
 */

/** Вариант оформления. */
export type BrandId = 'gmk' | 'colver';

/** Тексты бренда в интерфейсе. */
export interface BrandConfig {
  id: BrandId;
  /** Название продукта целиком (заголовок вкладки, копирайт). */
  productName: string;
  /** Дескриптор рядом со знаком — как направления в брендбуке (GMK TEAM, GMK SALES…). */
  descriptor: string;
  /** Слоган продукта. */
  tagline: string;
  /** Слоган компании из брендбука (у Colver — нет). */
  motto: readonly [string, string] | null;
  copyright: string;
}

const YEAR = new Date().getFullYear();

const BRANDS: Record<BrandId, BrandConfig> = {
  gmk: {
    id: 'gmk',
    productName: 'GMK SALES',
    descriptor: 'SALES',
    tagline: 'Контроль качества звонков',
    motto: ['Энергия', 'девелопмента'],
    copyright: `© ${YEAR} GMK`,
  },
  colver: {
    id: 'colver',
    productName: 'Colver',
    descriptor: '',
    tagline: 'Контроль качества звонков',
    motto: null,
    copyright: `© ${YEAR} Colver`,
  },
};

/** Бренд, выбранный `index.html` (вне браузера — GMK). */
const resolveBrandId = (): BrandId =>
  typeof document !== 'undefined' &&
  document.documentElement.dataset['brand'] === 'colver'
    ? 'colver'
    : 'gmk';

/** Текущий бренд оформления. */
export const BRAND: BrandConfig = BRANDS[resolveBrandId()];

/** Оформление GMK (иначе — оригинальный Colver). */
export const IS_GMK = BRAND.id === 'gmk';
